import React from "react";
import { Spinner } from "react-bootstrap";

export default function FullPageLoading({ text, noSpinner }) {
    return (
        <div className="vh-100">
            <div className="h-50 d-flex flex-column justify-content-center align-items-center">
                {!noSpinner && (
                    <Spinner
                        animation="border"
                        variant="primary"
                        className="mb-5"
                    />
                )}
                <p className="text-center h5">
                    {" "}
                    {!!text ? text : "Loading..."}
                </p>
            </div>
        </div>
    );
}
